import { trimRingToBudget } from './diag-ring';
import { readStorageJson, removeStorage, writeStorageJson } from './safe-storage';

const RING_KEY = 'dbg-ring';
const RING_MAX = 200;
/**
 * Character cap on the whole ring. 200 entries bounds the COUNT, not the size -- each carries
 * whatever its call site passed -- and this shares sessionStorage with real app state.
 */
const RING_MAX_CHARS = 32768;

/** A ring entry that is not an array (stale format, key reused) degrades to an empty ring. */
function readRing(): any[] {
  const raw = readStorageJson<any[]>('session', RING_KEY, []);
  return Array.isArray(raw) ? raw : [];
}

export function dbg(tag: string, payload?: any): void {
  const arr = readRing();
  arr.push({ t: Date.now(), tag, payload });
  if (arr.length > RING_MAX) {
    arr.splice(0, arr.length - RING_MAX);
  }
  // Guarded by safe-storage: a refused write (or a payload that will not serialize) costs the
  // diagnostic entry, never the caller -- this is reached from reducers and components.
  writeStorageJson('session', RING_KEY, trimRingToBudget(arr, RING_MAX_CHARS));
}

if (typeof window !== 'undefined') {
  (window as any)['__dumpDbg'] = () => readRing();
  (window as any)['__clearDbg'] = () => removeStorage('session', RING_KEY);
}
